import React from "react";
import Typewriter from "typewriter-effect";
import styled from "styled-components";

const MyTitleMessage = styled.h1`
  position: absolute;
  width: 100%;
  top: 22rem;
  z-index: 1;
  margin-top: -125px;
  text-align: center;

  button {
    margin-top: 3.2rem;
    font-weight: 400;
    background: crimson;
    color: white;
    font-size: 1.8rem;
    padding: 5px 25px;
    border-radius: 6px;
    border: 2px solid crimson;
    text-decoration: none;
    transition: all 0.3s ease;
  }

  button:hover {
    color: crimson;
    background: white;
  }
  p {
    word-spacing: -15px;
    font-size: 5rem;
    font-weight: bold;
    font-family: "cursive";
    color: rgb(172, 63, 63);
    text-shadow: 2px 2px lightsalmon;
  }
  .a {
    color: whitesmoke;

    text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);

    letter-spacing: 2px;
  }

  div {
    .main {
      font-size: 27px;
    }
    .sub {
      font-size: 40px;
      letter-spacing: 2px;
      font-weight: 500;
      color: orangered;
      text-shadow: 2px 2px lightyellow;
    }
  }

  @media (max-width: 330px) {
    position: absolute;
    width: 100%;
    top: 20rem;
    z-index: 1;
    margin-top: -125px;
    text-align: center;
    p {
      font-size: 3rem;
    }
  }
`;

const TitleMessage = () => (
  <MyTitleMessage>
    <div className="titleMessage">
      <div className="heading">
        <div className="main text-center mb-3">
          <span class="a">Hi,My Name is</span>
          <br />
          <span>
            <p>Yash Verma</p>
            <span class="a">And I am </span>
          </span>
        </div>
        <div className="sub">
          <Typewriter
            options={{
              strings: [
                "Web Developer",
                "Programmer",
                "Free Lancer",
                "Designer",
              ],
              autoStart: true,
              loop: true,
              delay: 50,
            }}
          />
        </div>
        <button>Hire Me</button>
      </div>
    </div>
  </MyTitleMessage>
);

export default TitleMessage;
